import Api from "../api";
import store from "../../../store";

class Types extends Api {
  constructor() {
    super();
    this.uri = "cms/v4/types";
    this.requiresAuth = false;
  }

  getTypes(params, customRequest) {
    let url = this.uri + (params ? "?" + params : "");
    return this.get(url, {}, this.requiresAuth, customRequest);
  }

  getTypesBlockOrder(id) {
    let url = this.uri + "/" + id + "/block/order";
    return this.get(url, {}, this.requiresAuth);
  }

  postTypesBlockOrder(id, data) {
    let url = this.uri + "/" + id + "/block/order";
    return this.post(url, data, true);
  }

  getType(id) {
    let url = this.uri + "/" + id;
    return this.get(url, {}, this.requiresAuth);
  }

  searchTypes(params, data) {
    let url = this.uri + "/search" + (params ? "?" + params : "");
    return this.post(url, data, this.requiresAuth);
  }

  updateType(params, id) {
    let url = this.uri + "/" + id;
    return this.put(url, params, true);
  }

  createType(params) {
    let url = this.uri;
    return this.post(url, params, true);
  }

  deleteType(id) {
    let url = this.uri + "/" + id;
    return this.delete(url, {}, true);
  }
}

export default new Types();
